import {differenceInSeconds, format, isBefore} from 'date-fns';
import {t} from '../common/getTranslations';

/**
 * NEXT 기획과 맞게 열람/구매시기로부터 얼마 지났는지를 표시해주는 정책을 구현한 함수입니다.
 * 다음과 같은 로직으로 동작합니다.
 * - 1분 전 (1분 미만)
 * - N분 전 (1분~60분)
 * - N시간 전 (1시간~24시간)
 * - N일 전 (1일~6일)
 * - YY.MM.DD (열림 7일 후)
 *
 * 참고: https://podotree.atlassian.net/wiki/spaces/SVC/pages/2874049063/NEXT#2.-%EB%82%A0%EC%A7%9C-%ED%91%9C%EA%B8%B0
 */
export function timeago({
  date,
  baseDate = new Date(),
}: {
  date: Date;
  baseDate?: Date;
}) {
  // baseDate 정보가 date 정보보다 이전이라면, 예외상황이므로 date 정보를 yy.MM.dd로 변환해 리턴해줍니다.
  if (isBefore(baseDate, date)) {
    return format(date, t('date_formatter_short_year_dot'));
  }

  const diffInSeconds = differenceInSeconds(baseDate, date);
  if (diffInSeconds < 60) {
    return `${t('common_period_ago', {
      values: {
        value: t('common_period_minute', {values: {value: 1}}),
      },
    })}`;
  } else if (diffInSeconds < 60 * 60) {
    return `${t('common_period_ago', {
      values: {
        value: t('common_period_minute', {
          values: {value: Math.floor(diffInSeconds / 60)},
        }),
      },
    })}`;
  } else if (diffInSeconds < 60 * 60 * 24) {
    return `${t('common_period_ago', {
      values: {
        value: t('common_period_hour', {
          values: {value: Math.floor(diffInSeconds / (60 * 60))},
        }),
      },
    })}`;
  } else if (diffInSeconds <= 60 * 60 * 24 * 7) {
    return `${t('common_period_ago', {
      values: {
        value: t('common_period_day', {
          values: {value: Math.floor(diffInSeconds / (60 * 60 * 24))},
        }),
      },
    })}`;
  } else {
    return format(date, t('date_formatter_short_year_dot'));
  }
}
